export function mapGraphqlErrors(error) {
  if (typeof error.map === "function")
    return error.map(mapGraphqlErrors)?.flat(1);
  if (error.graphQLErrors?.length)
    return error.graphQLErrors.map(mapGraphqlErrors)?.flat(1);
  if (error.networkError?.result?.errors?.length)
    error.networkError?.result?.errors.map(mapGraphqlErrors)?.flat(1);
  if (error.message) return [{ message: error.message }];
  return error;
}
